<i18n>
{
	"no":{
		"title": "EDI logg",
		"noEdiRecorded": "Ingen EDI logger funnet",
		"direction": "Retning",
		"messageType": "Meldingstype",
		"messageFormat": "Meldingsformat",
		"edipartName" : "EDI Part",
		"created": "Opprettet",
		"status": "Status",
		"outbound": "Utgående EDI",
		"inbound": "Inngående EDI"
	},
	"en":{
		"title": "EDI log",
		"noEdiRecorded": "No EDI logs found",
		"direction": "Direction",
		"messageType": "Message type",
		"messageFormat": "Message format",
		"edipartName" : "EDI Part",
		"status": "Status",
		"created": "Created",
		"outbound": "Outbound EDI",
		"inbound": "Inbound EDI"
	}
}
</i18n>
<template>
	<div class="edi-log">
		<div class="edi-log-header">
			<t-panel-header
				:text="$t('title')"
				type="bp"
				icon="edi"
				size="md"
			/>

			<t-timpex-icon
				icon="refresh"
				size="small"
				type="bp"
				color="blue"
				style="cursor: pointer"
				:class="{rotate: isFetchingLogs}"
				@click.native="fetchEdiLogs"
			/>
		</div>

		<t-grid
			v-if="ediLog.length > 0"
			:items="ediLog"
			:columnDefinitions="columnDefinitions"
			:rowHeight="40"
			:sort="sort"
			class="edi-log-content"
			@rowDoubleClick="onEdiLogClicked"
		>
			<template v-slot:type="{item}">
				<div class="edi-direction">
					<t-timpex-icon
						v-if="item.type ==='outbound'"
						icon="export"
						type="bp"
						color="blue"
						style="padding-left: 3px;"
					/>
					<t-timpex-icon
						v-else
						icon="import"
						type="bp"
						color="blue"
						style="padding-left: 3px;"
					/>
					<span>{{$t(item.type)}}</span>
				</div>

			</template>
			<template v-slot:status="{item}">
				<EdiStatusIcon :ediLogRecord="item" />
			</template>
		</t-grid>

		<t-no-content-panel
			v-else
			:text="$t('noEdiRecorded')"
			icon="edi"
			iconType="bp"
			class="edi-log-content"
			noBetweenGap
		/>


		<InspectInboundTransmissionDialog :isShown="showInboundDialog" @close="showInboundDialog = false" />
		<InspectOutboundTransmissionDialog :isShown="showOutboundDialog" @close="showOutboundDialog = false" />
	</div>
</template>

<script>

import moment from 'moment';

import InspectInboundTransmissionDialog from '../../edi/transmissionOverview/inspection/inbound/InspectInboundTransmissionDialog.vue';
import { mapActions as inboundActions } from '../../edi/transmissionOverview/inspection/inbound/store/inbound.store';
import  { mapActions as outboundActions }  from '../../edi/transmissionOverview/inspection/outbound/store/outbound.store';
import InspectOutboundTransmissionDialog from '../../edi/transmissionOverview/inspection/outbound/InspectOutboundTransmissionDialog.vue';
import EdiStatusIcon from './ediLog/EdiStatusIcon.vue';
import { mapState, mapActions } from '../store/newOrder.store';

export default {

	name:'EdiLog',

	components:{
		InspectInboundTransmissionDialog,
		InspectOutboundTransmissionDialog,
		EdiStatusIcon
	},

	data() {
		return {
			defaultColumnDefinitions: {},
			sort: [{ field: 'created', direction: 'desc' }],
			showInboundDialog: false,
			showOutboundDialog: false,
			isFetchingLogs: false
		};
	},

	computed: {
		...mapState(['ediLog']),
		columnDefinitions() {
			return [
				{
					field: 'type',
					displayName: this.$t('direction'),
					valueGetter: item => item.type
				},
				{
					field: 'status',
					displayName: this.$t('status'),
					width:60,
					valueGetter: item => item.error
				},
				{
					field: 'messageType',
					displayName: this.$t('messageType'),
					valueGetter: item => item.messageType,
					resizable: true,
				},
				{
					field: 'messageFormat',
					displayName: this.$t('messageFormat'),
					valueGetter: item => item.messageFormat,
					resizable: true,
				},
				{
					field: 'edipartName',
					displayName: this.$t('edipartName'),
					valueGetter: item => item.edipartName,
					resizable: true,
				},
				{
					field: 'created',
					displayName: this.$t('created'),
					valueGetter: item => moment(item.created.date, 'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm:ss')
				}
			];
		}
	},

	methods: {
		...inboundActions(['inspectInboundTransmission']),
		...outboundActions(['inspectOutboundTransmission']),
		...mapActions(['fetchEdiLog']),


		async  fetchEdiLogs() {
			if (this.isFetchingLogs)
				return;
			this.isFetchingLogs = true;
			await this.fetchEdiLog();
			setTimeout(async() => {
				this.isFetchingLogs = false;
			}, 1500);
		},
		async onEdiLogClicked(id) {
			let selectedEdiLog = this.ediLog.find(x => x.id === id);
			if (selectedEdiLog.type === 'outbound') {
				await this.inspectOutboundTransmission(selectedEdiLog.transmissionId);
				this.showOutboundDialog = true;
			} else {
				await this.inspectInboundTransmission(selectedEdiLog.transmissionId);
				this.showInboundDialog = true;
			}
		}
	}
};
</script>

<style lang="scss" scoped>

.edi-log{
	height: 100%;
	min-height: inherit;
}

.edi-log-header{
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 15px;
	background: white;
}

.edi-direction{
	display: grid;
	width:100%;
	grid-template-columns: 50px 200px;
}

.edi-log-content{
	height: calc(100% - 60px);
	width: 100%;
	min-height: inherit;
}

.rotate {
  animation: rotation 1s infinite linear;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}

</style>